import React, { useState, useEffect } from "react";
import placeholderArticle from "../../img/placeholder-article.svg";

/**
 * <img> avec fallback automatique si la source ne charge pas
 * (URL morte, 404, image supprimée…). Évite les vignettes cassées
 * façon "image absente" du navigateur.
 *
 * Props :
 *  - src : source souhaitée
 *  - fallback : source de secours (def. placeholder de marque)
 *  - alt, className, ...rest : transmis au <img>
 */
const SafeImage = ({ src, fallback = placeholderArticle, alt = "", className, ...rest }) => {
    const initial = src && String(src).trim() !== "" ? src : fallback;
    const [currentSrc, setCurrentSrc] = useState(initial);

    // Si la prop src change (filtre, navigation…), on repart de la bonne source.
    useEffect(() => {
        setCurrentSrc(src && String(src).trim() !== "" ? src : fallback);
    }, [src, fallback]);

    const handleError = () => {
        if (currentSrc !== fallback) {
            setCurrentSrc(fallback);
        }
    };

    return (
        <img
            src={currentSrc}
            alt={alt}
            className={className}
            loading="lazy"
            onError={handleError}
            {...rest}
        />
    );
};

export default SafeImage;
